import { ListActionTarget } from '../../../models/ListActionTarget';

export const targetToIconCode = (target: ListActionTarget): string => {
    switch (target) {
        case ListActionTarget.List:
            return 'add';
        case ListActionTarget.Cart:
        default:
            return 'shopping_cart';
    }
};
